import React, { useState } from 'react';
import locations from './locationsData';
import {Helmet} from 'react-helmet';
import {siteData} from './locationsData';
import AutoMenu from '../../react/AutoMenu';


const Catering = () => {
 
  return (
  <div className="catering-page">
     <div className="location-page">

<Helmet>
  <title>{siteData.shortName} | Catering</title>
</Helmet>

 

    <h2 id="order" style={{visibility: 'hidden', height: "0px", margin: "0", padding: "0"}}>Order Online</h2>

      <div className="ordering-menu">
        <AutoMenu
          altStyleA
          // darkMode={true}
          tagsToShow={['catering']}
          width={500}>

          </AutoMenu>
      </div>
    </div>

  </div>
  );
};

export default Catering;